import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';
import { TextMaskModule } from 'angular2-text-mask';

import {Title} from '@angular/platform-browser';
import {FormBuilder, Validators} from "@angular/forms";
import {TripService} from '../../trip.service';
import {CountryService } from '../../../common/country.service';
import {IMyDpOptions} from 'mydatepicker';


@Component({
  selector: 'app-trip-edit-attendee',
  templateUrl: './trip-edit-attendee.component.html',
  styleUrls: ['./trip-edit-attendee.component.css', '../../../app.component.css', '../../admin.css'],
  providers: [TripService,CountryService]
})
export class TripEditAttendeeComponent implements OnInit {

  userId: any;
  eventId: any;
  eventUserId:any;
  counts: any;
  countries:any;
  detailArray:any;
  states:any;
  flags:any;
  users:any;
  errorMessage:any;
  spinner: boolean = false;
  htmlVariable: any;
  showCounts:any;
  public mask =[/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  todayDate = new Date();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: {year: this.todayDate.getFullYear(), month: this.todayDate.getMonth()+1, day: this.todayDate.getDate()+1}
  };


  constructor(private pageTitle: Title,private router: Router, public dialogRef: MdDialogRef<TripEditAttendeeComponent>, private formBuilder: FormBuilder, private tripService: TripService,private snackBar: MdSnackBar,private countryService:CountryService) { }

  ngOnInit() {
    if(this.eventId && this.userId){
      this.getAttendeeInfo(this.eventId,this.userId)
    }else{
      this.snackBar.open('something went wrong','',{duration:4000});
      setTimeout(()=>{ this.dialogRef.close(); }, 2000);
    }

    this.countryService.getCountries().subscribe(response => {
      this.countries = response;
    });

    this.users=({
      userId : '',
      firstName : '',
      lastName : '',
      email : '',
      cellPhone : '',
      password : '',
      rePassword : '',
      eventUser : {
        eventId : this.eventId,
        userId : '',
        badgeName : '',
        firstName : '',
        lastName : '',
        cellPhone : '',
        companyName : '',
        addressLine1 : '',
        addressLine2 : '',
        countryId : '',
        stateId : '',
        city : '',
        zipcode : '',
        workPhone : '',
        extension : '',
        type : 'Trip',
        designation : 'Guest',
        arriveByPlane : 0,
        arriveFlightName : '',
        arriveFlightNumber : '',
        arriveDateTime : '',
        arriveDateTime_ : new Date(),
        arriveNames : '',
        returnFlightName : '',
        returnFlightNumber : '',
        returnDateTime : '',
        returnDateTime_ : new Date(),
        returnNames : '',
        attendAwardCelebration : 1,
        userExcursions : [],
        price : 0.00,
        mealRestriction : 0,
        mealChoice : 0,
        mealComments : '',
        parentEventUserId:'',
        parentUserId:'',
        title : '',
        dob : '',
        dob_ : '',
        emergencyPhone : '',
        roomType:'',
        roomTypeComments:'',
        beddingPreference:'',
        emergencyName:''
      }
    });
  }
  dateTimeFormat(dt){
    if(dt)
    {
      var m = dt.getMonth()+1;
      if(m<10)
        m='0'+m;
      var d = dt.getDate();
      if(d<10)
        d='0'+d;
      return dt.getFullYear()+'-'+m+'-'+d+' 00:00:00';
    }
    else
      return '';
  }

  usDateTimeFormat(dt){
    if(dt)
    {
      if(typeof dt=='string')
      {
        dt = dt.split(' ');
        dt = dt[0].split('-');
        return dt[1]+'/'+dt[2]+'/'+dt[0];
      }
      else
      {
        var m = dt.getMonth()+1;
        if(m<10)
          m='0'+m;
        var d = dt.getDate();
        if(d<10)
          d='0'+d;
        return m+'/'+d+'/'+dt.getFullYear();
      }
    }
    else
      return '';
  }

  editAtt(attendeeForm){

    if(attendeeForm.valid && this.FormValid(attendeeForm)){
     // this.users.eventUser.dob = this.dateTimeFormat(this.users.eventUser.dob_);

      this.spinner = true;
      this.tripService.updateTripAttendee({  users:this.users }).subscribe(
              response => {
            this.spinner = false;
            if(response.status)
            {
              this.snackBar.open('Attendee updated successfully','',{duration:4000});
              this.dialogRef.close(response.status);
            }
            else{
              this.snackBar.open(response.msg,'',{duration:4000});
              this.spinner = false;
            }
          },
              error => {
            this.spinner = false;
          }
      );
    }
  }

  getAttendeeInfo(eventId,userId){
    this.spinner = true;
    this.tripService.getAttendeeInfo({eventId:eventId,userId:userId,eventUserId:this.eventUserId}).subscribe(
            response => {
          this.spinner = false;
          this.detailArray = response;
          if(response.attendeeInfo.length>0) {
            this.users = {
              firstName: response.attendeeInfo[0].firstName,
              lastName: response.attendeeInfo[0].lastName,
              email: (response.attendeeInfo[0].email)?response.attendeeInfo[0].email:'',
              cellPhone: (response.attendeeInfo[0].cellPhone)?response.attendeeInfo[0].cellPhone:'',
              userId: this.userId,
              eventUser: {
                eventId: this.eventId,
                eventUserId:(response.attendeeInfo[0].id)?response.attendeeInfo[0].id:'',
                badgeName: (response.attendeeInfo[0].badgeName)?response.attendeeInfo[0].badgeName:'',
                firstName : response.attendeeInfo[0].firstName,
                lastName : response.attendeeInfo[0].lastName,
                cellPhone : (response.attendeeInfo[0].cellPhone)?response.attendeeInfo[0].cellPhone:'',
                designation: (response.attendeeInfo[0].designation)?response.attendeeInfo[0].designation:'',
                type:(response.attendeeInfo[0].type)?response.attendeeInfo[0].type:'',
                attendAwardCelebration: (response.attendeeInfo[0].attendAwardCelebration)?response.attendeeInfo[0].attendAwardCelebration:0,
                mealRestriction: (response.attendeeInfo[0].mealRestriction)?response.attendeeInfo[0].mealRestriction:0,
                mealChoice: (response.attendeeInfo[0].mealChoice)?response.attendeeInfo[0].mealChoice:0,
                mealComments: (response.attendeeInfo[0].mealComments)?response.attendeeInfo[0].mealComments:'',
                companyName: (response.attendeeInfo[0].companyName)?response.attendeeInfo[0].companyName:'',
                addressLine1: (response.attendeeInfo[0].addressLine1)?response.attendeeInfo[0].addressLine1:'',
                addressLine2: (response.attendeeInfo[0].addressLine2)?response.attendeeInfo[0].addressLine2:'',
                countryId: (response.attendeeInfo[0].countryId)?response.attendeeInfo[0].countryId:0,
                stateId: (response.attendeeInfo[0].stateId)?response.attendeeInfo[0].stateId:0,
                stateName: (response.attendeeInfo[0].stateName)?response.attendeeInfo[0].stateName:'',
                countryName: (response.attendeeInfo[0].countryName)?response.attendeeInfo[0].countryName:'',
                city: (response.attendeeInfo[0].city)?response.attendeeInfo[0].city:'',
                zipcode: (response.attendeeInfo[0].zipcode)?response.attendeeInfo[0].zipcode:'',
                workPhone: (response.attendeeInfo[0].workPhone)?response.attendeeInfo[0].workPhone:'',
                extension: (response.attendeeInfo[0].extension)?response.attendeeInfo[0].extension:'',
                title : (response.attendeeInfo[0].title)?response.attendeeInfo[0].title:'',
                dob_ : (response.attendeeInfo[0].dob)?{year: (new Date(response.attendeeInfo[0].dob)).getFullYear(), month: (new Date(response.attendeeInfo[0].dob)).getMonth()+1, day: (new Date(response.attendeeInfo[0].dob)).getDate()}:'',
                emergencyPhone : (response.attendeeInfo[0].emergencyPhone)?response.attendeeInfo[0].emergencyPhone:'',
                emergencyName : (response.attendeeInfo[0].emergencyName)?response.attendeeInfo[0].emergencyName:'',
                roomType: (response.attendeeInfo[0].roomType)?response.attendeeInfo[0].roomType:'',
                roomTypeComments: (response.attendeeInfo[0].roomTypeComments)?response.attendeeInfo[0].roomTypeComments:'',
                beddingPreference: (response.attendeeInfo[0].beddingPreference)?response.attendeeInfo[0].beddingPreference:'',
              }
            };
            this.countryChanged(1);
          }else{
            this.spinner = false;
            this.snackBar.open('something went wrong','',{duration:4000});
            setTimeout(()=>{ this.dialogRef.close();}, 2000);
          }
        },
            error => {
          this.spinner = false;
          this.errorMessage = <any>error;
        }
    );
  }

  countryChanged(params){
    this.spinner = true;
    this.countryService.getStates(this.users.eventUser.countryId).subscribe(
            response => {
          this.spinner = false;
          if(params!=1)
            this.users.eventUser.stateId='';
          this.states = response;
        },
            error => {
          this.spinner = false;
          this.snackBar.open(error,'',{duration:4000});
        }
    );

    if(params.apply)
    {
      for(var i=0;i<this.countries.length;i++)
        if(this.countries[i].id==this.users.eventUser.countryId)
          this.users.eventUser.countryName = this.countries[i].name;
    }
  }

  stateChanged(){
    for(var i=0;i<this.states.length;i++)
      if(this.states[i].id==this.users.eventUser.stateId)
        this.users.eventUser.stateName = this.states[i].name;
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validatePhone(phone){
    var re = /^[0-9]{10}$/;
    return re.test(phone.replace(/-/g, ""));
  }

  validateZip(zip,country){
    return true;
    // if(country=='Canada')
    //   var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    // else
    //   var re = /^\d{5}(-\d{4})?$/;
    // return re.test(zip);
  }

  validateDigit(num,min,max){
    return num.match("^[0-9]{"+min+","+max+"}$");
  }

  FormValid(Id){
    var flag = true;
    //this.users.eventUser.dob = this.dateTimeFormat(this.users.eventUser.dob_);
    if(this.users.eventUser.designation=='Main User'){

      if(flag  && !this.validateEmail(this.users.email))
      {
        flag = false;
      }

      if(flag && !this.validatePhone(this.users.eventUser.cellPhone))
      {
        flag = false;
      }

      if(flag && !this.validatePhone(this.users.eventUser.emergencyPhone))
      {
        flag = false;
      }

      if(flag && !this.users.eventUser.emergencyName)
      {
        flag = false;
      }
    }else{
      if(flag && this.users.email && !this.validateEmail(this.users.email))
      {
        flag = false;
      }
      if(flag && this.users.eventUser.cellPhone && !this.validatePhone(this.users.eventUser.cellPhone))
      {
        flag = false;
      }
    }

    if(flag && !this.users.eventUser.firstName)
    {
      flag = false;
    }
    if(flag && !this.users.eventUser.lastName)
    {
      flag = false;
    }
    if(flag && !this.users.eventUser.dob)
    {
      flag = false;
    }
    if(flag && !this.users.eventUser.title)
    {
      flag = false;
    }

    return flag;

  }

  close() {
    this.dialogRef.close();
  }


}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/trip/trip-edit-attendee/trip-edit-attendee.component.ts